export default __webpack_public_path__ + "static/media/loading.acea8664.svg";